import React, { useState } from "react";
import Page from "../../components/page/Page";
import PageHeader from "../../features/page-header/PageHeader";
import Text from "@amzn/meridian/text";
import { Upload } from "../../components/upload/Upload";
import { Space } from "../../components/space/Space";
import Column from "@amzn/meridian/column";
import { TableComponent } from "../../components/table/TableComponent";
import Select, { SelectOption } from "@amzn/meridian/select";
import Row from "@amzn/meridian/row";
import Icon from "@amzn/meridian/icon";
import infoKnockoutTokens from "@amzn/meridian-tokens/base/icon/info-knockout";
import Box from "@amzn/meridian/box";
import Button from "@amzn/meridian/button";
import { Storage } from "aws-amplify";
import { downloadBlob } from "../../components/table/utils";

export const UploadComps: React.FC = () => {
    const [dataSourceType, setDataSourceType] = useState("");
    const [dataType, setDataType] = useState("");
    const [country, setCountry] = useState("");

    const dataSourceTypeOptions = [
        { label: "CoStar", value: "CoStar" },
        { label: "CBRE", value: "CBRE" },
    ];

    const compTypeOptions =
        dataSourceType === "CBRE"
            ? [
                  { label: "Vacancy", value: "VacancyRate" },
                  { label: "Cap", value: "CapRate" },
              ]
            : [
                  { label: "Rentals", value: "Rentals" },
                  { label: "Sales", value: "Sales" },
              ];

    const countryOptions = [
        { label: "United States", value: "US" },
        { label: "Canada", value: "CA" },
    ];

    const handleDownload = async () => {
        try {
            await Storage.get("COMPS-UPLOAD-TEMPLATE/Upload+Comps+Template.xlsx", {
                download: true,
                expires: 60,
                cacheControl: "no-cache",
            }).then(result => {
                downloadBlob(result.Body, "Upload_Comps_Template.xlsx");
            });
        } catch (error) {
            console.error("Error downloading file:", error);
        }
    };

    const acceptedFileTypes =
        dataSourceType === "CBRE"
            ? "application/pdf"
            : [
                  "application/pdf",
                  "text/csv",
                  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                  "application/vnd.ms-excel",
              ].join(",");

    return (
        <Page type="form" title="Upload comps" hasBreadcrumbs={true} actions={null}>
            <PageHeader />
            <Space size={"s"} />

            <Column spacing="400">
                <Text type="h200">Upload</Text>

                <Row alignmentHorizontal="justify">
                    <Column spacing={"400"} width="600px">
                        <Column spacing="l">
                            <Text type="b300">Country</Text>
                            <Select
                                value={country}
                                onChange={value => setCountry(value)}
                                placeholder="Select country..."
                            >
                                {countryOptions.map(option => (
                                    <SelectOption value={option.value} label={option.label} />
                                ))}
                            </Select>
                        </Column>

                        <Column spacing="l">
                            <Text type="b300">Data source</Text>
                            <Select
                                value={dataSourceType}
                                onChange={value => setDataSourceType(value)}
                                placeholder="Select one..."
                            >
                                {dataSourceTypeOptions.map(option => (
                                    <SelectOption value={option.value} label={option.label} />
                                ))}
                            </Select>
                        </Column>

                        <Column spacing="l">
                            <Text type="b300">Comp type</Text>
                            <Select
                                value={dataType}
                                onChange={value => setDataType(value)}
                                placeholder="Select one..."
                            >
                                {compTypeOptions.map(option => (
                                    <SelectOption value={option.value} label={option.label} />
                                ))}
                            </Select>
                        </Column>
                    </Column>

                    <Box type="fill" width={"25rem"} spacingInset="500">
                        <>
                            <Row>
                                <Icon tokens={infoKnockoutTokens} />
                                <Text type="h300">Use template to import data</Text>
                            </Row>
                            <Space size={"s"} />
                            <Text type="b300">Use the correct template to import data</Text>
                            <Space size={"s"} />
                            <Button
                                minWidth={300}
                                type="tertiary"
                                size="medium"
                                onClick={handleDownload}
                            >
                                {" "}
                                Download Template{" "}
                            </Button>
                        </>
                    </Box>
                </Row>

                <Upload
                    dataSourceType={dataSourceType || null}
                    dataType={dataType || null}
                    country={country || null}
                    useCase={"DATA_SOURCE_FILE_UPLOAD"}
                    s3Prefix={`APPRAISER-AI/DATA-SOURCE-UPLOAD/${country}/${dataSourceType}/${dataType}/`}
                    acceptedFileTypes={acceptedFileTypes}
                />

                <Column>
                    <Text type="h200">Upload history</Text>
                    <TableComponent
                        onSearch={true}
                        tableName={"audit-records-data-source-files"}
                        tableQueryParams={{
                            eventUseCase: "DATA_SOURCE_FILE_UPLOAD",
                            businessUseCase: "SMART",
                            exclusiveStartKey: null,
                        }}
                        showDividers={true}
                    />
                </Column>
            </Column>
        </Page>
    );
};
